import React from "react"
import { Modal } from "react-bootstrap"
import ProgressBar from "react-bootstrap/ProgressBar"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import classes from "./FuwDeviceHeicModal.module.scss"

const FuwDeviceHeicModal = props => {
  const {
    convertedHeicImages,
    totalConvertedHeicImages,
    cancelConvertingHeicImagesRef,
    openConvertingHeicImagesModal,
    setOpenConvertingHeicImagesModal
  } = props

  const [t] = useTranslation()

  const handleCancel = () => {
    cancelConvertingHeicImagesRef.current = true

    setOpenConvertingHeicImagesModal(false)
  }

  const percentage =
    Math.round((convertedHeicImages / totalConvertedHeicImages) * 100)

  const label =
    `${convertedHeicImages} / ${totalConvertedHeicImages}`

  return (
    <Modal
      show={openConvertingHeicImagesModal}
      onHide={handleCancel}
      centered
    >
      <div className={classes["container"]}>
        <h4 className={classes["title"]}>
          {"در_حال_تبدیل_فرمت_فایل_ها"}
        </h4>

        <div className={classes["progress"]}>
          <ProgressBar
            animated
            now={percentage}
            variant="success"
          />

          <span className={classes["label"]}>
            {label}
          </span>
        </div>

        <div className={classes["footer"]}>
          <Button
            color="danger"
            onClick={handleCancel}
          >
            {t("لغو")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default FuwDeviceHeicModal